import { RouteSuggestion } from '@/javascript/domain/entities'
import { RemoteRouteSuggestion } from '@/javascript/data/entities'
import { ListMapper } from './mapper'

export class RouteSuggestionMapper extends ListMapper<RouteSuggestion, RemoteRouteSuggestion> {
  constructor() { super() }

  toEntity (data: RemoteRouteSuggestion): RouteSuggestion {
    return {
      reference: data.reference,
      origin: {
        address: data.origin.address,
        lat: data.origin.lat,
        lng: data.origin.lng
      },
      destination: {
        address: data.destination.address,
        lat: data.destination.lat,
        lng: data.destination.lng
      },
      geometry: data.geometry,
      pointsCount: data.works_count,
      totalTime: data.total_time_seconds,
      serviceTime: data.service_time_seconds,
      travelTime: data.travel_time_seconds,
      totalDistance: data.total_distance_meters,
      points: data.points.map(work => ({
        sequence: work.sequence,
        type: work.type,
        reference: work.reference,
        arrivalTime: work.arrival_time,
        departureTime: work.departure_time,
        location: {
          address: work.location.address,
          lat: work.location.lat,
          lng: work.location.lng
        }
      }))
    }
  }
}
